import { Verification } from '../auth.service';
import { AuthPlatformEnum } from './auth-platform.enum';

export interface LoginResponseModel {
    redirect_url: string;
}

export class LoginBaseModel {
    token: string;
    version = 2;
    groupInviteMode = 0;
    groupInviteKey: string;
    groupCodeMode = 0;
    groupCode: string;

    // re-captcha validation payload
    site_verify_response: Verification;

    // optional platform params, i.e., Zendesk, Smiletrain
    platform?: AuthPlatformEnum;
    returnTo?: string;
    brandId?: string;
    localeId?: string;
    timestamp?: string;

    constructor () { }
}
